import React, {memo, useCallback, useMemo, useRef, useState} from "react";
import {PasswordContainer} from "../../../../components/PasswordContainer";
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer";
import "./index.scss";
import {useDispatch, useSelector} from "react-redux";
import {useRPC} from "../../../../hooks/rpc";
import {useMessage} from "../../../../hooks/message";
import {useLocalization} from "../../../../hooks/localization";
import {setEntityListAction} from "../../../../store/control/actions";
import {IftttState} from "../../../../store/control/state";
import {SettingInputComponent} from "../../../../components/Settings/SettingInputComponent";
import {SettingCheckBoxComponent} from "../../../../components/Settings/SettingCheckboxComponent";
import {useKeyboard} from "../../../../hooks/keyboard";
import {useHistory} from "react-router-dom";
import {onClickHandler} from "../../../../utils/onclick";

const BACK_URL = '/settings';

export const IfDoEditScreen = memo(function IftttEditScreen() {
    const {t} = useLocalization();
    const [rpc] = useRPC();
    const dispatch = useDispatch();
    const history = useHistory();
    const {success, failure} = useMessage();
    const inputRef = useRef<HTMLInputElement>(null);
    const ifttt = useSelector((state) => state.control.iftttList);
    const [email, setEmail] = useState(ifttt.e_mail)
    const [password, setPassword] = useState(ifttt.password)
    const [token, setToken] = useState(ifttt.token)
    const [isEnabled, setIsEnabled] = useState(ifttt.is_enabled)

    const [setActiveInput, renderKeyboard] = useKeyboard();

    const onSavePressed = useCallback(
        () => {
            const newIfttt: IftttState = {
                e_mail: email,
                password: password,
                token: token,
                is_enabled: isEnabled
            }
            rpc.setIftttState(newIfttt)
                .then(() => {
                    history.push(BACK_URL);
                    success(t('SUCCESSFULLY_EDITED'));
                    dispatch(setEntityListAction(newIfttt, 'ifttt'))
                })
                .catch(failure);
        },
        [t, dispatch, success, failure, rpc, email, password, token, isEnabled, history]
    );

    const onClickLogin = useCallback(() => {
        rpc.LoginIFTTTCloud(email, password).then(data => {
            if (data.success) {
                success("Giriş Başarılı");
            } else {
                failure("Şifre Yanlış")
            }
        }).catch(console.log)
    }, [rpc, email, password, success, failure]);

    const onClickLogout = useCallback(() => {
        rpc.LogOutIFTTTCloud()

    }, [rpc]);

    const onBlur = useCallback(() => {
        setActiveInput(null);
    }, [setActiveInput]);

    const buttons = useMemo(() => [
        {
            text: t('save'),
            className: 'green',
            onClick: onSavePressed,
        },
        {
            text: t('cancel'),
            className: 'red',
            url: BACK_URL,
        }], [t, onSavePressed],
    );

    return (
        <>
            <PasswordContainer requiredRole="default" isFullscreen={true}>
                <SettingsPageContainer buttons={buttons} className="service-edit" backUrl={"/settings"}>
                    <div className="content-divider">
                        <div className="content-wrapper">
                            <SettingInputComponent
                                placeholder={"E-Mail"}
                                label={"E-Mail"}
                                value={email}
                                setValue={setEmail}
                                setActiveInput={setActiveInput}
                                onBlur={onBlur}
                                ref={inputRef}
                            />
                            <SettingInputComponent
                                placeholder={t("password")}
                                label={t("password")}
                                type="password"
                                value={password}
                                setValue={setPassword}
                                setActiveInput={setActiveInput}
                                onBlur={onBlur}
                            />
                            <SettingInputComponent
                                placeholder={"token"}
                                label={t("token")}
                                value={token}
                                setValue={setToken}
                                setActiveInput={setActiveInput}
                                onBlur={onBlur}
                                disabled
                                readOnly
                            />
                            <div className="ifttt-action-container">
                                <button {...onClickHandler(onClickLogin)}>GİRİŞ</button>
                                <button {...onClickHandler(onClickLogout)}>ÇIKIŞ</button>
                            </div>
                        </div>
                        <div className="content-wrapper">
                            <SettingCheckBoxComponent
                                label={t("sip_status")}
                                set={() => setIsEnabled(prev => !prev)}
                                value={isEnabled}
                            />
                        </div>
                    </div>
                </SettingsPageContainer>
            </PasswordContainer>
            {renderKeyboard()}
        </>
    )
});
